import React, { ReactElement } from "react";
import { useRoutes } from "react-router-dom";

import { ROUTES } from "@/constants/routes_sidebar/routes-constant";

// lazy import routes
const Admin = React.lazy(() => import("@/pages/workforce/admin"));
const Customer = React.lazy(() => import("@/pages/clients/customer"));
const Employee = React.lazy(() => import("@/pages/workforce/employees"));
const ManagerPage = React.lazy(() => import("@/pages/workforce/manager"));
const SubContractor = React.lazy(
  () => import("@/pages/workforce/sub-contractor"),
);
const WorkForceSettings = React.lazy(
  () => import("@/pages/workforce/settings"),
);

export const WorkspaceRoutes = (): ReactElement => {
  const routes = useRoutes([
    { path: `${ROUTES.ADMIN}`, element: <Admin /> },
    { path: `${ROUTES.MANAGER}`, element: <ManagerPage /> },
    { path: `${ROUTES.EMPLOYEE}`, element: <Employee /> },
    { path: `${ROUTES.CUSTOMERS}`, element: <Customer /> },
    { path: `${ROUTES.SUB_CONTRACTOR}`, element: <SubContractor /> },
    {
      path: `${ROUTES.WORKFORCE_SETTINGS}`,
      element: <WorkForceSettings />,
    },
  ]) as ReactElement;

  return routes;
};
